/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    CASH: 'cash',
    ORDER: 'order',
    PROFILE: 'profile',
    WARN: 'warn',
    INFO: 'info',
};
